var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Carousel'), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 d-flex"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-embed', {
    attrs: {
      "type": "iframe",
      "aspect": "16by9",
      "src": "https://www.youtube.com/embed/hSdWLNm3Xo0"
    }
  }), _c('br')], 1)])])]), _vm._m(2), _vm._m(3), _vm._m(4), _c('div', {
    staticClass: "col-12 py-5"
  }, [_c('div', {
    staticClass: "row mx-5"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "mb-2",
    staticStyle: {
      "max-width": "20rem"
    },
    attrs: {
      "title": "Spiderman",
      "img-src": require("@/assets/img/spiderman.jpg"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm._v(" $12.990 ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "#",
      "variant": "primary"
    }
  }, [_vm._v("Comprar")])], 1)], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "mb-2",
    staticStyle: {
      "max-width": "20rem"
    },
    attrs: {
      "title": "Harry Potter",
      "img-src": require("@/assets/img/harry.jpg"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm._v(" $12.990 ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "#",
      "variant": "primary"
    }
  }, [_vm._v("Comprar")])], 1)], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "mb-2",
    staticStyle: {
      "max-width": "20rem"
    },
    attrs: {
      "title": "F. Mercury",
      "img-src": require("@/assets/img/freddy.jpg"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm._v(" $12.990 ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "#",
      "variant": "primary"
    }
  }, [_vm._v("Comprar")])], 1)], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('b-card', {
    staticClass: "mb-2",
    staticStyle: {
      "max-width": "20rem"
    },
    attrs: {
      "title": "Dr. Strange",
      "img-src": require("@/assets/img/drstrange.jpg"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm._v(" $12.990 ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "#",
      "variant": "primary"
    }
  }, [_vm._v("Comprar")])], 1)], 1)]), _c('br'), _c('hr'), _c('br')]), _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4 p-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._m(6), _c('div', {
    staticClass: "col-12"
  }, [_c('p', [_vm._v(" Hay una gran cantidad de Funkos, pero entre todos estos, hay algunos que destacan, ya sea por el personaje al que representa o por su apariencia atractiva. Éstos Funko Pop se convierten en los Funko Pop más buscados a lo largo del tiempo, una consecuencia directa de su calidad. Aqui podras conocer algunos de los Funko Pop más buscados. ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "/buscados",
      "variant": "primary"
    }
  }, [_vm._v("Ver más")])], 1)])]), _c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4 p-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._m(8), _c('div', {
    staticClass: "col-12"
  }, [_c('p', [_vm._v(" En Estados Unidos se sirven a la venta cereales Funko Pop basados en películas como It, Bitelchús, Gremlins o Pesadilla en Elm Street. Cada caja tiene un diseño único en función de la película que represente, así como un color diferente en los cereales. Además, cada caja cuenta con su propia mini figura Funko Pop. ¡Toda una delicia para los amantes del coleccionismo! ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "/curiosidades",
      "variant": "primary"
    }
  }, [_vm._v("Ver más")])], 1)])]), _c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-4 p-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._m(10), _c('div', {
    staticClass: "col-12"
  }, [_c('p', [_vm._v(" Encuentra cientos de Funko POP de tus series, películas y dibujos animados favoritos en su tamaño regular o en la versión pocket para que siempre los lleves contigo y así nunca dejes de lucir tu colección en cualquier parte. Compra tu colección de Funko POP tv, Marvel, Disney, Anime y más en un solo lugar. Te mostraremos todas nuestras promociones. ")]), _c('b-button', {
    staticClass: "btn-funko-primary w-100",
    attrs: {
      "href": "/promociones",
      "variant": "primary"
    }
  }, [_vm._v("Ver más")])], 1)])])])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12 pt-5 pb-3"
  }, [_c('h1', {
    staticClass: "funko-home-title"
  }, [_vm._v("NO TE QUEDES SIN TU COLECCIÓN DE FUNKO POP!!")]), _c('hr')]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('p', {
    staticClass: "funko-home-bienvenida mb-5 pl-5 ml-5 mr-5 pr-5"
  }, [_vm._v(" Bienvenidos al mundo de Funko Pop, te contaremos la historia, datos curiosos, podras intercambiar tus funkos y comprar para completar tu colección de uno de los mayores fenómenos de coleccionistas modernos. ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12 py-5"
  }, [_c('h1', {
    staticClass: "funko-home-title"
  }, [_vm._v("LA HISTORIA DE LOS FUNKO POP")]), _c('hr')]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-10 texto-imagen"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-6"
  }, [_c('p', {
    staticClass: "mx-5 mb-5"
  }, [_vm._v(" En 1998, Mike Becker, diseñador de camisetas y buscador de juguetes raros, tenía entre ceja y ceja el muñeco-hucha con el famoso Big Boy de la cadena de 'fast food' americana. El problema es que todo aquel que se la quería vender pedía una millonada por ella. Ante tal panorama decidió fabricar su propia versión en China por mucho menos dinero. Al poco tiempo nacía Funko. Becker empezó con 35.000 dólares de su propio bolsillo trabajando desde su casa y su primer muñequito, como no podía ser de otra manera, fue el Big Boy que había estado buscando durante tanto tiempo, esta vez en versión muñeco sin hucha. Acto seguido fue a por su primera línea bautizada con el nombre de Wacky Wobblers (algo así como los “locos que se tambalean”) cuyos protagonistas eran figuras animadas como Popeye, Dick Tracy o personajes de las marcas de cereales de General Mills. Becker empezó con 35.000 dólares de su propio bolsillo trabajando desde su casa y su primer muñequito, como no podía ser de otra manera, fue el Big Boy que había estado buscando durante tanto tiempo, esta vez en versión muñeco sin hucha. Acto seguido fue a por su primera línea bautizada con el nombre de Wacky Wobblers (algo así como los “locos que se tambalean”) cuyos protagonistas eran figuras animadas como Popeye, Dick Tracy o personajes de las marcas de cereales de General Mills. ")])]), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-6 mb-5"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("@/assets/img/BOY.jpg")
    }
  })])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12 py-5"
  }, [_c('h1', {
    staticClass: "funko-home-title"
  }, [_vm._v("LOS 4 FUNKOS MÁS VENDIDOS")]), _c('hr')]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12"
  }, [_c('img', {
    staticClass: "img-fluid funko-home-sub-img",
    attrs: {
      "src": require("@/assets/img/lupa.png")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "mt-4 funko-home-sub-title"
  }, [_vm._v("Funkos mas buscados")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12"
  }, [_c('img', {
    staticClass: "img-fluid funko-home-sub-img",
    attrs: {
      "src": require("@/assets/img/curiosidades.png")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "mt-4 funko-home-sub-title"
  }, [_vm._v("Curiosidades")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12"
  }, [_c('img', {
    staticClass: "img-fluid funko-home-sub-img",
    attrs: {
      "src": require("@/assets/img/promociones.png")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "mt-4 funko-home-sub-title"
  }, [_vm._v("Promociones")])]);
}]

export { render, staticRenderFns }